/**
 * Enum that represents all the types of devices
 */
export enum DeviceType {
  DigitalSignageNetworkPlayer = 'Digital Signage Network Player',
  DistributionSender = 'Distribution Sender',
  WebCache = 'WebCache',
  // ProxyAgent = 'ProxyAgent', // deprecated
}
